import apiClient from "../../../apiClient";
import mutationWrapper from "../../mutationWrapper";
import { dataPribadiKey } from "../../queries/DataPribadi/useFetchDataPribadi";
import { checkProfileKey } from "../../queries/User/useFetchCheckProfile";
import getQueryClient from "../../queryClient";

export async function addCV(file: File) {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("fileName", file.name);
  const res = await apiClient.post(`/CV`, formData);
  return res.data;
}

export const useAddCV = mutationWrapper(addCV, {
  onSuccess: () => {
    getQueryClient().invalidateQueries(dataPribadiKey);
    getQueryClient().invalidateQueries(checkProfileKey);
  },
});
